import React$1 from 'react';

const Xing = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40"
}, /*#__PURE__*/React$1.createElement("path", {
  fill: "#FF005F",
  fillRule: "evenodd",
  d: "M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm9.5 9h-3.316c-.49 0-.703.326-.879.66L18 23.317l4.665 9.023c.162.307.414.659.917.659h3.279c.197 0 .352-.079.435-.221.088-.148.085-.343-.006-.535l-4.628-8.915c-.005-.007-.005-.016 0-.023l7.268-13.55c.091-.192.093-.387.007-.535C29.853 9.08 29.697 9 29.5 9zM14.5 13.619h-3.196c-.193 0-.354.072-.436.215-.084.147-.071.336.018.527l2.161 4.026c.004.008.004.013 0 .02l-3.395 6.45c-.089.19-.085.38 0 .527.081.142.225.235.417.235h3.196c.478 0 .708-.347.872-.665l3.45-6.567c-.013-.022-2.197-4.123-2.197-4.123-.16-.305-.4-.645-.89-.645z"
}));

export default Xing;
